import { render } from "./HelpPage.vue?vue&type=template&id=96fb43c0"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"

import "./HelpPage.vue?vue&type=style&index=0&id=96fb43c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__